<template>
  <div class="w-full mb-3 overflow-x-auto overflow-y-hidden steps-scroll-wrapper">
    <div class="flex items-start justify-between relative min-w-[580px] md:min-w-0 pb-1">
      <div
        v-for="(item, index) in processedSteps"
        :key="index"
        :class="[
          'relative flex flex-col',
          index < processedSteps.length - 1 ? 'flex-1' : 'flex-none'
        ]"
      >
        <!-- Horizontal connecting line between circles -->
        <div
          v-if="index < processedSteps.length - 1"
          class="absolute top-3 left-6 right-0 h-[1.5px] bg-[#E2E8F0] z-0"
        />

        <!-- Step Circle and Label -->
        <div class="relative z-10 flex flex-col items-start pr-2">
          <div
            :class="[
              'h-6 w-6 rounded-full flex items-center justify-center text-xs font-semibold select-none transition-colors duration-200',
              item.current
                ? 'bg-primary text-white shadow-sm'
                : item.done
                  ? 'bg-primary text-white'
                  : 'bg-[#737373] text-white'
            ]"
          >
            <b-icon
              v-if="item.done"
              icon="check"
              scale="1.2"
              class="text-white"
            />
            <span v-else>{{ item.number }}</span>
          </div>
          <div
            :class="[
              'mt-1 text-xs md:text-sm whitespace-nowrap transition-colors duration-200',
              item.current
                ? 'text-primary font-semibold'
                : item.done
                  ? 'text-[#333333] font-medium'
                  : 'text-[#737373]'
            ]"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepsDefault',
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    stepsData: {
      type: Array,
      default: () => [
        {
          number: 1,
          name: 'AI Customer Service',
          done: false,
        },
        {
          number: 2,
          name: 'Produk',
          done: false,
        },
        {
          number: 3,
          name: 'Ekspedisi',
          done: false,
        },
        {
          number: 4,
          name: 'Jenis Pembayaran',
          done: false,
        },
        {
          number: 5,
          name: 'Pengaturan Tambahan',
          done: false,
        },
      ],
    },
  },
  computed: {
    processedSteps() {
      return this.stepsData.map(step => ({
        ...step,
        current: step.number === this.currentStep,
        done: step.done || step.number < this.currentStep,
      }))
    },
  },
}
</script>

<style scoped>
.steps-scroll-wrapper {
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.steps-scroll-wrapper::-webkit-scrollbar {
  display: none;
}
</style>
